import { render } from "./ReturnRequestSummary.vue?vue&type=template&id=6be82904&scoped=true&ts=true"
import script from "./ReturnRequestSummary.vue?vue&type=script&lang=ts"
export * from "./ReturnRequestSummary.vue?vue&type=script&lang=ts"

import "./ReturnRequestSummary.vue?vue&type=style&index=0&id=6be82904&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6be82904"]])

export default __exports__